<div class="navbar-header pull-right">
  <div class="dropdown drop-perfil">
    <button class="btn btn-default dropdown-toggle" type="button" id="dropdownMenu1" data-toggle="dropdown" aria-expanded="false">
    <span class="glyphicon glyphicon-user"></span>
    <label>{{ username }}</label>
    <span class="glyphicon glyphicon-cog"></span>
    </button>
    <ul class="dropdown-menu" role="menu" aria-labelledby="dropdownMenu1">
      <!--
      <li role="presentation">
        <a role="menuitem" tabindex="-1" href="#">Configurações do Perfil</a>
      </li>
      <li role="presentation">
        <a role="menuitem" tabindex="-1" href="#">Temas</a>
      </li>
      <li role="presentation" class="divider"></li>
      <li role="presentation">
        <a role="menuitem" tabindex="-1" href="#"><span class="glyphicon glyphicon-comment"></span><strong> ABRIR CHAMADO</strong></a>
      </li>
      <li role="presentation">
        <a role="menuitem" tabindex="-1" href="#"><span class="glyphicon glyphicon-question-sign"></span><strong> AJUDA</strong></a>
      </li>
      <li role="presentation" class="divider"></li>
      -->
      <ng-content></ng-content>
      <li role="presentation">
        <a role="menuitem" tabindex="-1" (click)="logout()">Sair</a>
      </li>
    </ul>
  </div>
</div>



// WEBPACK FOOTER //
// ./src/deps/pmv-common/pmv-common.d.ts.ɵbn.html